import createComponent from '../create-component';
export default createComponent([["title",{"key":"svg-title"}],["defs",{"key":"svg-defs"}],["circle",{"cx":"64","cy":"64","r":"64","mask":"url(#phantom-mono_svg__a)","key":"svg-circle"}]]);